import React from "react";
import GridItem from "./GridItem";

const GridContainer = ({ list = [] }) => {
  return (
    <div className="category-list-layout">
      <div className="row">
        {list ? (
          list.map((item, index) => <GridItem key={index} data={item} />)
        ) : (
          <h1>Loading...</h1>
        )}
      </div>
    </div>
  );
};

export default GridContainer;
